export default "__VITE_ASSET__M2U0My91__"